@if (totalPages > 1) {
  <nav aria-label="Page navigation" class="mt-4">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 0">
        <button class="page-link" (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 0" aria-label="Previous">
          <span aria-hidden="true">&laquo;</span>
        </button>
      </li>

      @for (page of pages; track page) {
        <li class="page-item" [class.active]="currentPage === page">
          <button class="page-link" (click)="onPageChange(page)">{{ page + 1 }}</button>
        </li>
      }

      <li class="page-item" [class.disabled]="currentPage === totalPages - 1">
        <button class="page-link" (click)="onPageChange(currentPage + 1)" [disabled]="currentPage === totalPages - 1" aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
        </button>
      </li>
    </ul>
  </nav>
}
